import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { mpfCampanhasSchema } from './schema';

/**
 * Formulário da barra lateral. Sob `withObjectBrowser` porque o campo `href`
 * de cada item é um `object_browser` aninhado num `object_list` — mesmo
 * arranjo de `ConteudosRelacionados/Data.tsx`.
 *
 * Sem `dataAdapter` próprio: o item guarda só a referência, então não há campo
 * nenhum para preencher a partir do conteúdo escolhido.
 */
const Data = (props: any) => {
  const { block, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfCampanhasSchema({
    intl,
    activeObject: props.activeObject,
    setActiveObject: props.setActiveObject,
  });

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id: string, value: unknown) =>
        onChangeBlock(block, { ...data, [id]: value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default withObjectBrowser(Data);
